import { render } from "./viewGroupTraining.html?vue&type=template&id=bb8124a8&scoped=true&ts=true&external"
import script from "./ViewGroupTraining.vue?vue&type=script&lang=ts"
export * from "./ViewGroupTraining.vue?vue&type=script&lang=ts"

import "./ViewGroupTraining.vue?vue&type=style&index=0&id=bb8124a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8124a8"]])

export default __exports__